// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__12rKw","colMaxWidth":"Table_colMaxWidth__2XURd"};